import axios from "../libs/api.request.js";
// 发货列表
export const addOrder = data => {
    return axios.request({
      url: "pc/shipping/addOrder",
      method: "get",
      params: data
    });
  };
// 提交发货
export const putShipping = data => {
    return axios.request({
      url: "pc/shipping",
      method: "post",
      data: data
    });
  };
// 发货列表
export const getShipping = params => {
    return axios.request({
      url: "pc/shipping",
      method: "get",
      params: params
    });
  };
// 删除物流
export const delShipping = params => {
    return axios.request({
      url: "pc/shipping",
      method: "delete",
      params: params
    });
  };
// 物流详情
export const detailsShipping = params => {
    return axios.request({
      url: `pc/shipping/${params.id}`,
      method: "get"
    });
  };
// 查询能追加物流的订单
export const addOrderShipping = params => {
    return axios.request({
      url: `pc/shipping/addOrder`,
      method: "get",
      params: params
    });
  };

  export const exportOrderList = params => {
    return axios.request({
      url: `pc/order/exportOrderList`,
      method: "get",
      params: params
    });
  }


// WEBPACK FOOTER //
// ./src/api/logistics.js